'use client';

import React from 'react';
import Link from 'next/link';
import { useLanguage } from '@/app/context/AppContext';

export default function SharedRegister() {
  const { lang } = useLanguage();
  const pt = lang === 'pt';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <div className="flex justify-center mb-6">
          <Link href="/">
            <img src="/logo.png" className="h-10" alt="Autonomo" />
          </Link>
        </div>
        <h2 className="text-center text-3xl font-extrabold text-gray-900">
          {pt ? 'Junte-se à Autônomo' : 'Join Autônomo'}
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600 mb-8">
          {pt
            ? 'Registe-se para contratar talentos ou encontrar oportunidades de trabalho'
            : 'Sign up to hire talent or find work opportunities'}
        </p>

        <div className="bg-white py-8 px-4 shadow sm:rounded-xl sm:px-10 border border-gray-100 space-y-4">

          <Link href="/register/seeker" className="group block w-full text-left p-6 border-2 border-gray-200 hover:border-teal-500 rounded-xl transition-colors hover:bg-teal-50">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-teal-100 text-teal-700 rounded-full flex items-center justify-center shadow-sm">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-lg group-hover:text-teal-800 transition">
                  {pt ? 'Autônomo / Prestador' : "I'm an Autônomo / Job Seeker"}
                </h3>
                <p className="text-sm text-gray-500 mt-1">
                  {pt ? 'Encontre trabalho, submeta propostas e cresça na sua carreira.' : 'Find jobs, submit bids, and grow your career.'}
                </p>
              </div>
            </div>
          </Link>

          <Link href="/register/recruiter" className="group block w-full text-left p-6 border-2 border-gray-200 hover:border-amber-500 rounded-xl transition-colors hover:bg-amber-50">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center shadow-sm">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-lg group-hover:text-amber-800 transition">
                  {pt ? 'Contratante Particular / Empresa' : "I'm a Recruiter / Company"}
                </h3>
                <p className="text-sm text-gray-500 mt-1">
                  {pt ? 'Publique vagas, analise candidatos e contrate talentos.' : 'Post jobs, review candidates, and hire talent.'}
                </p>
              </div>
            </div>
          </Link>

        </div>

        <div className="mt-8 text-center text-sm text-gray-600">
          {pt ? 'Já tem conta?' : 'Already have an account?'}{' '}
          <Link href="/login" className="font-semibold text-teal-600 hover:underline transition">
            {pt ? 'Entrar aqui' : 'Log in here'}
          </Link>
        </div>
      </div>
    </div>
  );
}
